import { useRecoilQuery } from '../../../../../../hooks/useRecoilQuery';
import { fixedFeeCustomerNetWorthQuery } from '../../../../../../store/fixedFee/selector';

interface UseStepOneNetWorthProps {
  accountNumber?: number;
  excludeEquity: boolean;
}

interface UseStepOneNetWorthResult {
  adjustedNetWorth?: number;
  loadingNetWorth: boolean;
  netWorthError: boolean;
  netWorthRefresher: () => void;
}

export const useStepOneNetWorth = ({
  accountNumber,
  excludeEquity,
}: UseStepOneNetWorthProps): UseStepOneNetWorthResult => {
  const { data, loading, error, refresher } = useRecoilQuery(
    fixedFeeCustomerNetWorthQuery({
      accountNumber: accountNumber || 0,
      excludeEquity,
    }),
    {
      if: () => !!accountNumber,
    }
  );

  return {
    adjustedNetWorth: data?.data?.totalInvested,
    loadingNetWorth: loading,
    netWorthError: !!error,
    netWorthRefresher: refresher,
  };
};
